import React from "react";

import { useSelector } from "react-redux";

import { selectProgressCompletion } from "@hubcapp/state";

import { OverallProgressStateProviderProps } from "./types";
import OverallProgress from "./OverallProgress";
import Skeleton from "./components/Skeleton";

const OverallProgressStateProvider: React.FC<OverallProgressStateProviderProps> = ({
  loading = false,
}) => {
  const completion = useSelector(selectProgressCompletion);

  if (loading) {
    return <Skeleton />;
  }

  return (
    <OverallProgress loading={loading} overallProgressPercentage={completion} />
  );
};

export default OverallProgressStateProvider;
